import React from "react"
import styled, { css } from "styled-components"

import { Flex } from "components/box"

type Props = {
  children: React.ReactNode
  bgImage: string
  bgImageMobile: string
}

const SkinnyHero = styled(Flex)<Props>`
  display: flex;
  align-items: center;
  justify-content: center;

  background-image: url(${props => props.bgImageMobile});
  background-repeat: no-repeat;
  background-position: bottom right;
  background-size: cover;

  @media screen and (min-width: ${props => props.theme.breakpoints.md}px) {
    ${props => css`
      background-image: url(${props.bgImage});
    `}
  }
`

export default SkinnyHero
